__turbopack_context__.v({
  "baseFieldItem": "HOD5dq_baseFieldItem",
  "iconsWrapper": "HOD5dq_iconsWrapper",
  "trigger": "HOD5dq_trigger" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "value": "HOD5dq_value",
});
